import Vue from "vue";
import { getSiteByCustomerClientAddress } from "../../api/site";
import { getDomainSite, setDomainSite } from "../../utils/site";

const site = {
    namespaced: true,
    state: {
        site: null,
    },
    mutations: {
        GET_SITE_BY_CUSTOMER_CLIENT_ADDRESS: (state, payload) => {
            state.site = payload;
        },
    },
    actions: {
        getSiteByCustomerClientAddress({ commit }, payload) {
            return getSiteByCustomerClientAddress(payload).then((response) => {
                commit("GET_SITE_BY_CUSTOMER_CLIENT_ADDRESS", response.data);
                setDomainSite(JSON.stringify(response.data));
                return response.data;
            });
        },
    },
};

export default site;



// WEBPACK FOOTER //
// ./src/store/modules/site.js